const messages = {
  bonus: {
    title: "Bonuskrediittien yhteenveto",
    description: "Bonukset euroina myönnetään osallistuville yrityksille ilmoitettujen myyntilukujen perusteella.",
    lastMonth: "Edellinen kuukausi",
    currentMonth: "Nykyinen kuukausi",
    totalCurrentYear: "Yhteensä kuluvana vuonna",
    totalLastYear: "Yhteensä viime vuonna",
  },
  points: {
    title: "Pistekrediittien yhteenveto",
    period: "Kuluva kalenterivuosi ({year})",
    totalAwarded: "Myönnetyt pisteet yhteensä",
    redeemed: "Lunastetut pisteet",
    totalBalance: "Pisteiden kokonaissaldo",
    redemptionRate: "Lunastetut pisteet prosentteina myönnetyistä pisteistä",
    averageAwarded: "Keskimäärin myönnetyt pisteet ostettua rengasta kohti",
    standardAwarded: "Nettopisteet lasketuista myyntiriveistä, palautukset mukaan lukien",
    bsPlusInclBooster: "Pisteet myyntiriveiltä, joiden määrä on positiivinen",
    perTire: "Lunastetut pisteet ostettua rengasta kohti",
  },
  tires: {
    title: "Renkaiden määrän yhteenveto",
    description: "Asiakkaiden ostamat renkaat",
    prevMonth: "Edellinen kuukausi",
    totalLastYear: "Yhteensä viime vuonna",
    purchaseIndirect: "Osto tukkukaupan kautta (epäsuora)",
    purchaseDirect: "Osto tukkukaupan kautta (suora)",
    totalCurrentYear: "Yhteensä kuluvana vuonna",
    currentMonth: "Nykyinen kuukausi",
  },
  participating: {
    title: "Osallistuvien asiakkaiden yhteenveto",
    description: "BRIDGESTONE PLUS -ohjelmaan rekisteröityvät yritykset voidaan yhdistää asiakasnumeron kautta.",
    total: "Yhteensä",
    newThisMonth: "Uudet tässä kuussa",
    newThisYear: "Uudet tänä vuonna",
    createdInCurrentMonth: "Luotu kuluvana kuukautena (ylläpitäjän toimesta)",
    loginsCurrentYear: "Kirjautumiset kuluvana vuonna (ehtojen hyväksymisen jälkeen)",
  },
  brand: {
    title: "Brändi",
    description: "Ostoksesi yksityiskohtaisesti",
    centerTitle: "Brändin\nmukaan",
  },
  rim: {
    title: "Vanne",
    centerTitle: "Vannekoon\nmukaan",
  },
  tireGoals: {
    title: "Rengastavoitteet",
    subtitle: "Ansaitse pisteitä rengasostoistasi.",
    centerTitle: "Rengaskoon\nmukaan",
    tiresRemaining: "Jäljellä olevat renkaat",
    progressionTarget: "Edistymistavoite: ",
    pointsEarnedPurchases: "ansaitut pisteet\n" + "ostoistasi",
    pointsEarnedBoosters: "ansaitut pisteet\n" + "boostereista",
    purchasesDetail: "Ostoksesi yksityiskohtaisesti",
    cta: "Lue lisää pisteistäsi",
    pointsTitle: "Pisteesi",
    pointsSubtitle: "Bridgestone-ostoista ansaitut pisteet",
    achievementsTitle: "Saavutuksesi",
    achievementsSubtitle: "Vuotuinen sitoumuksesi:",
    achievementsSubtitle2: "rengasta",
  },
  score: {
    title: "Pisteet",
    total: "Yhteensä",
    credits: "Hyvitykset",
    deductions: "Vähennykset",
        unlockedPoints: "Avatut pisteet",
        pendingPoints: "Odottavat pisteet",
  },
  score_extended: {
    title1: "Pistesaldo",
    title2: "Bonus euroina",
    balance: "Pistesaldo",
    bonus_in_euro: "Bonus euroina",
    date: "Päivämäärä",
    added_points: "Lisätyt pisteet",
    total_bands: "Brändejä yhteensä",
    goal: "Tavoite",
    tyres_previous_year: "Viime vuonna myydyt renkaat",
    tyres_current_year: "Tänä vuonna myydyt renkaat",
    target_this_year: "Tämän vuoden myyntitavoite",
    bonus_this_year: "Ansaittu bonus (€)",
    loyal_minimum: "Vähimmäisuskollisuustaso",
    bonus_multiplier: "Bonuksen kerroin",
  },
  lastImport: {
    label: "Viimeisin myyntitietojen tuonti:",
    on: "",
  },
  wholesalerTable: {
    title: "Osallistuvat asiakkaat yksityiskohtaisesti",
    description: "Alta löydät yritykset, jotka ovat rekisteröityneet BRIDGESTONE PLUS -ohjelmaan yrityksesi asiakasnumerolla. Voit käyttää suodattimia lajitteluun tai hakua asiakkaiden etsimiseen.",
    columns: {
      customer_number: "As. nro",
      address_company_name: "Yritys",
      address_street: "Katu ja numero",
      address_postal_code: "Postinumero",
      address_city: "Kaupunki",
      last_registration: "Viimeisin rekisteröinti",
      network: "Verkosto",
      profile_group: "Ryhmä",
      tires_amount: "Renkaiden määrä",
      point_balance: "Pistesaldo",
      bonus: "Bonus",
      details: "Tiedot",
    },
    searchPlaceholder: "Hae",
  },
  dealerTable: {
    columns: {
      date: "Päivämäärä",
      wholesaler_bs_plus: "Tukkuri BS+",
      customer_number: "Asiakasnumero",
      article: "Artikkeli",
      brand: "Brändi",
      product: "Tuote",
      type: "Tyyppi",
      inch: "Tuuma",
      season: "Kausi",
      amount: "Määrä",
      points: "Pisteet",
      activity: "Toiminta",
      total_points: "Pisteet yhteensä",
    },
    title: "Jälleenmyyjätaulukko",
    description: "Yhteenveto jälleenmyyjien toiminnasta",
  },
  business_units: {
    title: "Liiketoimintayksiköt",
    centerTitle: "Yksikön\nmukaan",
  },
  season: {
    title: "Kausi",
    centerTitle: "Vuodenajan\nmukaan",
  },
};

export default {
  messages,
};
